import * as actionTypes from './types';

function setReviewFeedContent(state, action) {
    return {
        ...state,
        [action.meta]: [...state[action.meta] || [], ...action.payload],
    };
}

const reducerFunctions = {
    [actionTypes.SET_REVIEW_FEED_CONTENT]: setReviewFeedContent,
};

export default function reducer(state = {}, action) {
    if (!reducerFunctions.hasOwnProperty(action.type)) {
        return state;
    }

    return reducerFunctions[action.type](state, action);
}
